export default class CountryComponentStep2 {
    constructor(step2ContrySelector) {
        this.selector = $(step2ContrySelector);

        this.regionSelect = $('#basketorder-customer-region');
        this.postalCodeInput = $('#basketorder-customer-kod_pocztowy');

        this.initializeEvents();
    }

    initializeEvents() {
        this.selector.on('change', (event) => this.getCountryInformation());
    }

    setActiveCountry(code, countryName)
    {

        this.selector.removeAttr('readonly');
        this.selector.val(countryName);
        this.selector.attr('readonly',true);

        $('#basketorder-customer-kraj-step2-code').val(code);
        // this.getCountryInformation(code);
    }


    // getCountryInformation(countryCode)  {
    //     $.ajax({
    //         type : 'GET',
    //         url : `/delivery/ups/get-country/?format=json&h=0&countrycode=${countryCode}`,
    //         success : response => this.onUpsCountryResponse(response)
    //     });
    // }

    showPostalCodeField() {

        this.postalCodeInput.prop('disabled', false);
        this.postalCodeInput.parent().parent().css({display : 'flex'});
    }

    showRegionField() {

        this.regionSelect.prop('disabled', false);
        this.regionSelect.parent().parent().removeClass('hide').css({display : 'flex'});
    }

    hidePostalCodeField() {

        this.postalCodeInput.prop('disabled', true);
        this.postalCodeInput.parent().parent().css({display : 'none'});
    }

    hideRegionField() {





        this.regionSelect.prop('disabled', true);
        this.regionSelect.parent().parent().css({display : 'none'});
    }

    onUpsCountryResponse(response) {



        if (response.regions.length > 0 && parseInt(response.country.postal_code_required) == 0) {

            response.regions.map(region => {
                this.regionSelect.append(`<option value="${region.id}">${region.name}</option>`);
            });


            this.hidePostalCodeField();
            this.showRegionField();

        }
        else {

            this.showPostalCodeField();
            this.hideRegionField();
        }
    }
}
